<script setup lang="ts">
import type { IHeroBanner } from './types'

const props = withDefaults(defineProps<IHeroBanner>(), {
  highPriority: true
})
</script>

<template>
  <section
    class="h-full rounded-lg bg-blue-50 px-4 py-5 text-brand-gray sm:p-6 md:rounded-2xl md:p-8"
  >
    <div class="flex items-center">
      <div class="mr-auto flex flex-col items-start gap-1 sm:gap-2 lg:max-w-2xl">
        <div v-if="props.intro" class="md:text-lg">{{ props.intro }}</div>
        <Heading v-if="props.heading" tag="h1">{{ props.heading }}</Heading>
        <div v-if="props.text" class="md:mt-1.5 md:leading-7 [&>p]:mb-4" v-html="props.text" />
        <div class="flex flex-row items-center gap-2 md:gap-3">
          <Button v-if="props.actionBtn" as-child class="px-3">
            <NuxtLinkLocale :to="props.actionBtn.url">{{
              $t(props.actionBtn.label)
            }}</NuxtLinkLocale>
          </Button>
          <div
            v-if="props.additionalActionBtn"
            class="flex flex-col items-center gap-2 md:flex-row md:gap-3"
          >
            <Button variant="orange" as-child>
              <NuxtLinkLocale :to="props.additionalActionBtn.url">{{
                $t(props.additionalActionBtn.label)
              }}</NuxtLinkLocale>
            </Button>
          </div>
        </div>
      </div>
      <NuxtImg
        v-if="props.image"
        :src="props.image"
        :alt="props.heading"
        class="pointer-events-none mr-auto hidden size-[18.5rem] select-none object-contain lg:block"
        format="avif,webp"
        :fetch-priority="props.highPriority ? 'high' : 'auto'"
        :loading="props.highPriority ? 'eager' : 'lazy'"
        :preload="props.highPriority"
        sizes="(min-width: 1024px) 296px, 1px"
      />
    </div>
  </section>
</template>
